import React from "react";

type StatItemProps = {
  value: string;
  label: string;
};

const StatItem: React.FC<StatItemProps> = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="text-base text-font dark:text-font-dark">{value}</span>
    <span className="text-xs text-font-600 dark:text-font-600-dark text-center">
      {label}
    </span>
  </div>
);

export default StatItem;

